// A tiny hyperscript helper for the overlay UI.

type Child = Node | string | null | undefined | false;

export interface Props {
  class?: string;
  text?: string;
  title?: string;
  lang?: string;
  id?: string;
  type?: string;
  href?: string;
  target?: string;
  rel?: string;
  tabindex?: string;
  min?: string;
  max?: string;
  step?: string;
  maxlength?: string;
  spellcheck?: string;
  autocapitalize?: string;
  autocomplete?: string;
  name?: string;
  inputmode?: string;
  placeholder?: string;
  rows?: string;
  style?: string;
  disabled?: boolean;
  role?: string;
  onclick?: (event: MouseEvent) => void;
  [attribute: `aria-${string}` | `data-${string}`]: string | undefined;
}

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, props: Props = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (value === undefined || value === false) continue;
    if (key === "class") element.className = value as string;
    else if (key === "text") element.textContent = value as string;
    else if (key === "onclick") element.addEventListener("click", value as EventListener);
    else if (key === "disabled") (element as HTMLButtonElement).disabled = true;
    else element.setAttribute(key, String(value));
  }
  for (const child of children) {
    if (child) element.append(child);
  }
  return element;
}

export function svg(markup: string): SVGElement {
  const template = document.createElement("template");
  template.innerHTML = markup.trim();
  return template.content.firstElementChild as SVGElement;
}

export const MARK = `<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="2" y="6" width="28" height="20" rx="6" fill="#171226" stroke="#ffd23f" stroke-width="2.6"/><circle cx="10" cy="16" r="3.1" fill="#ff5f9e"/><rect x="16" y="12.6" width="10" height="2.2" rx="1.1" fill="#3fd0e8"/><rect x="16" y="17.2" width="6.5" height="2.2" rx="1.1" fill="#ff5f9e"/></svg>`;

export function price(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}
